// components/UniqueExperiences.js
import React from 'react';
import "../css/styles.css"; 

const UniqueExperiences = () => {
  return (
    <div className="blog-container">


      <h1>Kenya’s Unique Travel Experiences</h1>



      <p>
        Picture this: You’re not just going on a vacation; you’re stepping into an unforgettable adventure that will leave you with memories to last a lifetime. Let me guide you through a journey like no other in Kenya.
      </p>

      <h2>Swim with Dolphins at Wasini Island </h2>
      <img
  src="/images/dolphin.jpg"
  alt="Dolphins experience"
  className="giraffemanor-image"
/>
      <p>
        Imagine gliding through crystal-clear waters off the coast of Wasini Island, located near the southern tip of Kenya, just south of the famous Diani Beach. The sun warms your skin as playful dolphins swim beside you, their graceful movements creating a peaceful connection with nature. Wasini Island offers an intimate, magical experience that feels like you are part of the ocean.
      </p>



      <h2>Hot Air Balloon Over Masai Mara and Amboseli</h2>
      <img
  src="/images/hotair.jpg"
  alt="Hot air experience"
  className="giraffemanor-image"
/>
      <p>
        As the sun begins to rise, you gently float into the sky. The vast plains of Masai Mara or Amboseli unfold beneath you, where elephants roam freely and the beauty of Africa is on full display. This is your chance to see the wild from a breathtaking perspective.
      </p>


 

      <h2>The Wildebeest Migration in Masai Mara </h2>
      <img
  src="/images/beest.jpg"
  alt="Wildbeast experience"
  className="giraffemanor-image"
/>
      <p>
        The earth trembles beneath millions of wildebeest as they rush across the plains in search of food and safety. Watching the Great Migration is like witnessing a dramatic, real-life documentary where nature’s raw beauty and power take center stage.
      </p>



 

      <h2>Breakfast with Giraffes at Giraffe Manor </h2>

      <img
  src="/images/breakfastgiraffe.png"
  alt="Giraffe Manor breakfast experience"
  className="giraffemanor-image"
/>
      <p>
        Start your day with a truly unique experience at Giraffe Manor in Nairobi, one of the most iconic boutique hotels in the world. Set in 12 acres of lush greenery, Giraffe Manor is home to a herd of endangered Rothschild giraffes who are free to roam the grounds. At breakfast, these gentle giants will join you, poking their long necks through the windows and over the tables to share in your meal—a magical start to your day in Kenya.
      </p>

      <p>
        These are not just experiences; they’re the kind of moments you’ll cherish forever. Follow for more exclusive travel tips and insider secrets.
      </p>

      <div className="hashtags">
        #Kenyasafari #Tanzaniasafari #LuxuryTravel #Luxurytravelinsider #AfricanSafari
      </div>
    </div>
  );
};

export default UniqueExperiences;
